import { useTranslation } from 'react-i18next'
import { ClerkSignUpWithMobileSupport } from '@/components/auth/ClerkSignUpWithMobileSupport'
import { useMobileDetection } from '@/hooks/useMobileDetection'
import { Logo } from '@/components/ui'

export function SignUpPage() {
  const { t } = useTranslation()
  const { isMobile } = useMobileDetection()

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-50 via-white to-indigo-50 px-4 py-12 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <Logo variant="full" size="lg" className="mx-auto" />
          <p className="mt-4 text-sm text-gray-600">
            {t('auth.signUpSubtitle')}
          </p>
        </div>

        <ClerkSignUpWithMobileSupport
          routing="path"
          path="/sign-up"
          signInUrl="/sign-in"
          afterSignUpUrl="/dashboard"
        />

        {/* Mobile hint */}
        {isMobile && (
          <div className="text-center text-xs text-gray-500">
            <p>{t('auth.mobileAppHint')}</p>
          </div>
        )}
      </div>
    </div>
  )
}